import { keyframes } from '@emotion/react';

const vibrate = keyframes`
0% {
	transform: rotate(0);
}

25% {
	transform: rotate(1.5deg);
}

75% {
	transform: rotate(-1.5deg);
}

100% {
	transform: rotate(0);
}`;

const fadeInFromBottom = keyframes`
0% {
	transform: translateY(400px) scale(0.1); 
	opacity: 0;
}
100% {
	transform: translateY(0) scale(1); 
	opacity: 1;
}
`;

const fadeInFromTop = keyframes`
0% {
	transform: translateY(-800px) scale(0.1); 
	opacity: 0;
}
100% {
	transform: translateY(0) scale(1); 
	opacity: 1;
}
`;

const animations = { vibrate, fadeInFromBottom, fadeInFromTop };

export default animations;
